import { Component } from 'preact'

import Editor from './index.js'

interface FormPostEditorProps {
  contentInputName: string
  contentPollInputName: string
  contentPollOptionsInputName: string
  attachmentsInputName: string
  disableFileAttachments: boolean
  profile?: 'openingPost'
}

export interface Poll {
  question: string
  options: string[]
}

interface FormPostEditorState {
  content: string
  attachments: Array<{}>
  hasFileInProgress: boolean
  poll: Poll
}

export default class FormPostEditor extends Component<FormPostEditorProps, FormPostEditorState> {
  constructor () {
    super()
    this.state = {
      attachments: [],
      hasFileInProgress: false,
      content: '',
      poll: {
        question: '',
        options: []
      }
    }
  }

  componentDidUpdate () {
    const createBtn: HTMLButtonElement | null = document.querySelector('button#topic_save')
    const loaderMessage: HTMLElement | null = document.querySelector('#file-in-progress-message')
    if (createBtn && loaderMessage) {
      createBtn.disabled = this.state.hasFileInProgress
      if (this.state.hasFileInProgress) {
        loaderMessage.classList.remove('is-hidden')
      } else {
        loaderMessage.classList.add('is-hidden')
      }
    }
  }

  render() {
    const { disableFileAttachments, contentInputName, contentPollInputName, contentPollOptionsInputName, attachmentsInputName } = this.props
    return (
      <div>
        <Editor
          {...this.props}
          isControl={false}
          disableFileAttachments={disableFileAttachments}
          onChange={(content: string, attachments: Array<{}>, hasFileInProgress: boolean) => this.setState({ content, attachments, hasFileInProgress })}
          placeholder='new.topic.placeholder.textarea'
          onPollUpdate={(poll: Poll) => { this.setState({ poll: poll }) }}
          canHavePoll
        />
        <input type='hidden' name={contentInputName} value={this.state.content} />
        <input type='hidden' name={contentPollInputName} value={this.state.poll.question} />

        {
          this.state.poll.options.map(option => (
            <input
              type='hidden'
              name={contentPollOptionsInputName}
              value={option}
              key={option}
            />
          ))
        }

        {this.state.attachments.map(attachment =>
          <input
            type='hidden'
            name={attachmentsInputName}
            value={JSON.stringify(attachment)}
            key={attachmentsInputName}
          />
        )}

      </div>
    )
  }
}
